import type { EventHandler } from "svelte/elements";
import { formatPhoneNumber } from "../formatPhoneNumber.js";

export const formatPhoneNumberOnInput: EventHandler<Event, HTMLInputElement> = (event) => {
	const originalLength = event.currentTarget.value.length;
	let cursorPosition = event.currentTarget.selectionStart ?? originalLength;
	const digits = event.currentTarget.value.replace(/[^\d+-]/gu, "");
	const formatted = formatPhoneNumber(digits);
	event.currentTarget.value = formatted;
	cursorPosition = cursorPosition + (formatted.length - originalLength);
	event.currentTarget.setSelectionRange(cursorPosition, cursorPosition);
};
